import { AnalyticsEvents } from './events';
import { trackEvent } from './track';
import type { SearchSource } from './events';

const timers = new Map<string, ReturnType<typeof setTimeout>>();

/** -- Debounced search typing (min 2 chars) to avoid one event per keystroke. */
export function trackSearchDebounced(
  source: SearchSource,
  query: string,
  delayMs = 1000
): void {
  const key = source;
  const existing = timers.get(key);
  if (existing) clearTimeout(existing);

  const trimmed = query.trim();
  if (trimmed.length < 2) {
    timers.delete(key);
    return;
  }

  timers.set(
    key,
    setTimeout(() => {
      timers.delete(key);
      trackEvent(AnalyticsEvents.SEARCH, {
        source,
        query: trimmed,
        length: trimmed.length,
      });
    }, delayMs)
  );
}

export function flushSearchDebounce(source: SearchSource): void {
  const existing = timers.get(source);
  if (existing) clearTimeout(existing);
  timers.delete(source);
}
